import RequestKeyService from "./requestKey.service";
var keyStore = require("../crypto/keyStore.js");
keyStore.upload.setKeyGet(RequestKeyService.getKey);
export default keyStore;



//////////////////
// WEBPACK FOOTER
// ./js/services/keyStore.service.ts
// module id = IeOO
// module chunks = 1 2 3